import { useMutation } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { PutTreatmentScheduleArgs, TreatmentScheduleTemplate } from "../schemas/Treatment";

export const usePutTreatmentSchedule = () => {
  const client = useApiClient();

  return useMutation<TreatmentScheduleTemplate, Error, PutTreatmentScheduleArgs>({
    mutationFn: args => client.putTreatmentSchedule(args),
  });
};
